import {
    CREATE_WISHLIST_ITEM,
    DELETE_WISHLIST_ITEM,
    EDIT_WISHLIST_ITEM,
    GET_WISHLIST_ITEM_BY_ID,
    GET_WISHLIST_ITEMS,
    GET_WISHLIST_UPDATES_COUNT,
    MARK_WISHLIST_SEEN,
} from './wishlist.types';

/**
 * This org's wishlist requests, one page.
 * @param {object} params  { category, status, search, skip, limit }
 * @param {string} load    pass 'noLoad' to refresh without the table spinner
 */
export const getWishlistItems = (params, load) => {
    return {
        type: GET_WISHLIST_ITEMS,
        payload: { params, load },
    };
};

/** How many of my requests TherapyLake updated since I last opened them. */
export const getWishlistUpdatesCount = () => ({ type: GET_WISHLIST_UPDATES_COUNT });

/** I opened this request — clear its red dot. Dispatch only for rows with `hasUpdate`. */
export const markWishlistSeen = (id) => ({ type: MARK_WISHLIST_SEEN, payload: { id } });

/** One request with freshly signed attachment URLs (the list rows carry none). */
export const getWishlistItemById = (id) => {
    return {
        type: GET_WISHLIST_ITEM_BY_ID,
        payload: { id },
    };
};

/**
 * `body.attachments` are the `StoredFile`s returned by `uploadFile()` — the
 * bytes are already in S3 by the time this fires.
 * @param {object} requestParams  the list params to refetch with afterwards
 */
export const createWishlistItem = (body, requestParams) => {
    return {
        type: CREATE_WISHLIST_ITEM,
        payload: { body, requestParams },
    };
};

/** Edit your own request. Status and proposed date are set by TherapyLake, not here. */
export const editWishlistItem = (id, body, requestParams) => {
    return {
        type: EDIT_WISHLIST_ITEM,
        payload: { id, body, requestParams },
    };
};

/** Delete your own request, with its comment thread and files. */
export const deleteWishlistItem = (id, requestParams) => {
    return {
        type: DELETE_WISHLIST_ITEM,
        payload: { id, requestParams },
    };
};
